/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface StatisticsResponse
 */
export interface StatisticsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StatisticsResponse
     */
    success?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof StatisticsResponse
     */
    data?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof StatisticsResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof StatisticsResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof StatisticsResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the StatisticsResponse interface.
 */
export function instanceOfStatisticsResponse(value: object): value is StatisticsResponse {
    return true;
}

export function StatisticsResponseFromJSON(json: any): StatisticsResponse {
    return StatisticsResponseFromJSONTyped(json, false);
}

export function StatisticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : json['data'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function StatisticsResponseToJSON(json: any): StatisticsResponse {
    return StatisticsResponseToJSONTyped(json, false);
}

export function StatisticsResponseToJSONTyped(value?: StatisticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

